import { useEffect } from "react"
import { useDispatch } from "react-redux"
import { Creators as HomeLayoutCreators } from "modules/home-layout/model"

/**
 * Custom hook to sync dashboard model ID changes with global Redux state.
 *
 * @param modelId The current model ID from dashboard context
 */
export function useModelSync(modelId: string) {
  const dispatch = useDispatch()

  useEffect(() => {
    if (modelId) {
      dispatch(HomeLayoutCreators.setModel(modelId))
    }
  }, [modelId, dispatch])
}
